<template>
    <div class="fullHeight">
        <MypageSideMenu :memberDropClose="false"/>
        <Card
            :page_title="page_title"
            iconclass="icon-icon-info mypage-title-icon"
        >
            <div class="col-sm-12">
                <p>会員情報の変更が完了しました。</p>
            </div>
        </Card>
        <MypageMenuFooter/>
    </div>
</template>

<script>
import MypageSideMenu from "./MypageSideMenu";
import Card from '../components/Card';
import MypageMenuFooter from './MypageMenuFooter';

export default {
    components: {
        MypageSideMenu,
        MypageMenuFooter,
        Card
    },
    data() {
        return {
            page_title: '会員情報変更完了',
        };
    },
    created() {
        this.initialize();
    },
    methods: {
        /** ----------------------------------------------
         * 初期表示時処理
         * ---------------------------------------------- */
        initialize() {
        }
    }
};
</script>

<style scoped>
</style>
